import { render, staticRenderFns } from "./ja.vue?vue&type=template&id=f30bf2fc&scoped=true&"
import script from "./ja.vue?vue&type=script&lang=js&"
export * from "./ja.vue?vue&type=script&lang=js&"
import style0 from "./ja.vue?vue&type=style&index=0&id=f30bf2fc&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f30bf2fc",
  null
  
)

export default component.exports